module.exports = __webpack_public_path__ + "img/waterpurifier37.dbf3f355.jpg";